<template>
  <div class="smsc-container">
    <vx-card>
      <div slot="no-body" class="flex flex-wrap items-center justify-between pl-3 pr-3">
        <div class="buttons-container flex flex-wrap items-center justify-start pb-3">
          <vs-button
            class="mt-3"
            @click="$router.push({ name: 'admin-product-list' })"
          >Back to Product</vs-button>
        </div>
        <div class="buttons-container flex flex-wrap items-center justify-end pb-3">
          <vs-button
            class="mt-3"
           @click="Save"
          >Save Product</vs-button>
        </div>
      </div>
    </vx-card>
    <vx-card>
      <div slot="no-body" class="p-3">
        <smsc-col>
          <smsc-col-item col-quantity="2" mt="0">
            <vs-input
              v-validate="'required'"
              data-vv-validate-on="input"
              class="w-100 deep"
              :class="{'is-danger': errors.has('Product Name')}"
              name="Product Name"
              label="Product Name"
              placeholder="Enter product name"
              v-model="payload.product_name"
            />
            <span class="text-danger text-xs">{{ errors.first('Product Name') }}</span>
          </smsc-col-item>

          <smsc-col-item col-quantity="2" mt="0">
            <label class="vs-input--label">Status</label>
            <v-select
              v-validate="'required'"
              data-vv-validate-on="input"
              name="status"
              placeholder="Enter status"
              :class="{'is-danger': errors.has('status')}"
              label="name"
              :reduce="(option) => option.value"
              :options="statusTypes"
              v-model="payload.status"
            />
            <span class="text-danger text-xs">{{ errors.first('status') }}</span>
          </smsc-col-item>
          <smsc-col-item  col-quantity="2" mt="0">
            <label class="vs-input--label">Type</label>
            <v-select
              v-validate="'required'"
              data-vv-validate-on="input"
              class="deep"
              name="type"
              placeholder="Enter type"
              :class="{'is-danger': errors.has('type')}"
              :options="types"
              :reduce="(option) => option.value"
              v-model="payload.public"
            />
            <span class="text-danger text-xs">{{ errors.first('type') }}</span>
          </smsc-col-item>
      </smsc-col>



      </div>
    </vx-card>
  </div>
</template>


<script>
    import vSelect from "vue-select";

    export default {
        name: "Edit",
      components: {
        vSelect
      },
      data:()=>({
        statusTypes: [{name: 'Active', value: 'active'}, {name: 'Inactive', value: 'inactive'}],
        types: [{label: 'Public', value: true}, {label: 'Private', value: false}],
        product_name:"",
        uuid:"",
        list:[],
        payload: {}

        // Selects value

        // Request body
      }),
      created() {
          this.uuid = this.$route.query['edit_product_uuid']
        this.GetList()
      },
      methods:{
        GetList() {
          this.$vs.loading()
          this.$store.dispatch('product/GetList', {
            product_uuid:this.uuid,


          })
            .then(res => {
               this.payload = res.items[0]

            })
            .catch()
            .finally(() => {
              this.$vs.loading.close()
            })
        },
        Save(){
          let params = {
            id : this.uuid,
            data:{
              product_name : this.payload.product_name,
              status : this.payload.status,
              public : this.payload.public
            }

          }
          this.$store.dispatch('product/Edit',params).then(()=>{
            this.$router.push({ name: 'Admin-product' })
            this.ShowSuccessMessage({ title: 'Success', text: 'Edit Product has been added' })
          }).catch(()=>{
            this.ShowErrorMessage({ title: 'Error'})
          }).finally(()=>{

          })
          },
        // Notify
        ShowSuccessMessage ({ title, text }) {
          this.$vs.notify({
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success',
            title,
            text
          })
        },
        ShowErrorMessage ({ title, text }) {
          this.$vs.notify({
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            title,
            text
          })
        },
      },
    }
</script>

<style lang="scss" scoped>
  .upload-form {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    .upload-form__item {
      flex-grow: 1;
      min-width: 270px;
      padding: 10px;

      &.first {

      }
      &.second {

      }
    }
  }

  .deep-upload /deep/ .con-input-upload{
    margin: 0;
    padding: 0!important;
  }
  .deep-upload /deep/ .con-img-upload{
    padding: 0!important;
  }
  @media (min-width: 601px) {
    .margin-top-content{
      margin-top: 18px;
    }

  }
</style>
